import { render, staticRenderFns } from "./ProductSidebar.vue?vue&type=template&id=1d4ac100&scoped=true&"
import script from "./ProductSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ProductSidebar.vue?vue&type=style&index=0&id=1d4ac100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4ac100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d4ac100')) {
      api.createRecord('1d4ac100', component.options)
    } else {
      api.reload('1d4ac100', component.options)
    }
    module.hot.accept("./ProductSidebar.vue?vue&type=template&id=1d4ac100&scoped=true&", function () {
      api.rerender('1d4ac100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/purchase/purchase-requisition/components/ProductSidebar.vue"
export default component.exports